document.addEventListener("DOMContentLoaded", function () {
  const sgrHandle = "taxa-sgr";

  async function updateSGR() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();

      const sgrProduct = cart.items.find(item => item.handle === sgrHandle);
      const totalBottles = cart.items
        .filter(item => item.handle !== sgrHandle)
        .reduce((sum, item) => sum + item.quantity, 0);

      if (totalBottles === 0 && sgrProduct) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: sgrProduct.key, quantity: 0 })
        });
        return;
      }

      if (sgrProduct && sgrProduct.quantity !== totalBottles) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: sgrProduct.key, quantity: totalBottles })
        });
      } else if (!sgrProduct && totalBottles > 0) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [{ quantity: totalBottles, id: window.sgrVariantId }]
          })
        });
      }
    } catch (error) {
      console.error("Eroare SGR:", error);
    }
  }

  document.addEventListener("change", updateSGR);
  document.addEventListener("click", e => {
    if (e.target.closest("[name='update'], [name='add'], [data-cart-update], [data-quantity-input]")) {
      setTimeout(updateSGR, 500);
    }
  });

  updateSGR();
});
